import { Injectable } from '@angular/core';
import { SessionQuery } from '../state-mangement/session/session.query';
import { TranslateService } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeDeCh from '@angular/common/locales/de-CH';
import localeDeChExtra from '@angular/common/locales/extra/de-CH';
import localeEn from '@angular/common/locales/en';
import localeEnExtra from '@angular/common/locales/extra/en';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeIt from '@angular/common/locales/it';
import localeItExtra from '@angular/common/locales/extra/it';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import { SettingsQuery } from '../state-mangement/settings/settings.query';
import { LanguageModel } from 'src/app/core/models/language/language.model';
import { TextKeys } from '../i18n/text-keys';

@Injectable({ providedIn: 'root' })
export class LangaugeService {

  constructor(
    private sessionQuery: SessionQuery,
    private translateService: TranslateService,
    private settingsQuery: SettingsQuery
  ) {}

  public getLanguage() {
    registerLocaleData(localeDeCh, localeDeChExtra);
    registerLocaleData(localeEn, localeEnExtra);
    registerLocaleData(localeFr, localeFrExtra);
    registerLocaleData(localeIt, localeItExtra);
    registerLocaleData(localeEs, localeEsExtra);
    registerLocaleData(localeDeCh, localeDeChExtra);

    let language = this.sessionQuery.getLanguage();

    //get language from store for user
    if (
      !this.sessionQuery.getPersonID() ||
      this.sessionQuery.getPersonID() === 0
    ) {
      language = this.settingsQuery.getValue()?.userLanguage;
    }

    switch (language) {
      case 'de':
        this.setLocale('de-CH');
        return 'de-CH';
      case 'en':
        this.setLocale(language);
        return 'en';
      case 'fr':
        this.setLocale(language);
        return 'fr';
      case 'it':
        this.setLocale(language);
        return 'it';
      case 'es':
        this.setLocale(language);
        return 'es';
      default:
        this.setLocale('de-CH');
        return 'de-CH';
    }
  }

  public getLanguageById(languageId: number) {
    switch (languageId) {
          case 1:
            return 'de-CH';
          case 2:
            return 'en';
          case 3:
            return 'fr';
          case 4:
            return 'it';
          case 5:
            return 'es';
          default:
            return 'de-CH';
        }
  }

  public getLanguageByLocale(locale: string) {
        switch (locale) {
          case 'de-CH':
            return 1;
          case 'en':
            return 2;
          case 'fr':
            return 3;
          case 'it':
            return 4;
          case 'en':
            return 5;
          default:
            return 1;
        }
  }

  public setLocale(lang: string) {
    if (lang == 'de-CH') {
      this.translateService.use('de');
    } else {
      this.translateService.use(lang);
    }
  }

  getLanguageList(): LanguageModel[] {
    return [
      {
        text: TextKeys?.languages?.de,
        short: 'de-CH',
        id: 1,
      } as LanguageModel,
      {
        text: TextKeys?.languages?.en,
        short: 'en',
        id: 4,
      } as LanguageModel,
      {
        text: TextKeys?.languages?.fr,
        short: 'fr',
        id: 2,
      } as LanguageModel,
      {
        text: TextKeys?.languages?.it,
        short: 'it',
        id: 3,
      } as LanguageModel,
      {
        text: TextKeys?.languages?.es,
        short: 'es',
        id: 5,
      } as LanguageModel,
    ];
  }
}

export const TIMEZONE = 'Europe/Zurich';
